import type { ReactNode } from 'react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { css } from '@sorare/css';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { FormControlLabel } from '#src/atoms/inputs/FormControlLabel/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

const cta = css`
  position: absolute;
  top: var(--unit);
  right: 0;
  color: var(--c-onBase-primary);
  text-decoration: underline;
  margin-top: var(--unit);
`;
const rowLabel = css`
  flex-direction: column-reverse;
  padding: var(--unit) 0;
  position: relative;

  &:not(:first-child) {
    border-top: 1px solid var(--c-nd-200);
  }
`;

type Props = {
  value: ReactNode;
  label: ReactNode;
  children?: ReactNode;
  readonly?: boolean;
};

export const EditableRow = ({
  readonly = false,
  label,
  value,
  children,
}: Props) => {
  const [isEditable, setIsEditable] = useState(false);

  return (
    <FormControlLabel
      className={rowLabel}
      label={<div className="pr-6">{label}</div>}
      control={
        <div className="flex w-full justify-between gap-2">
          {isEditable ? children : value}
          {!readonly && (
            <ButtonBase
              className={cta}
              disableDebounce
              onClick={() => setIsEditable(!isEditable)}
            >
              {isEditable ? (
                <FormattedMessage {...glossary.done} />
              ) : (
                <FormattedMessage {...glossary.edit} />
              )}
            </ButtonBase>
          )}
        </div>
      }
    />
  );
};
